export default __webpack_public_path__ + "static/media/korshem_2400.9102ae58.jpg";